import { useEffect } from "react";
import { DataTable, EmptyRow, Prompt, Screen, type Column } from "../components/primitives";
import { useWorkspaceStore } from "../stores/workspaceStore";
import type { WorkspaceSummary } from "../types/domain";
import css from "./screens.module.css";

const COLUMNS: Column[] = [
  { key: "workspace", label: "workspace", width: "1.6fr" },
  { key: "members", label: "members", width: "0.9fr" },
  { key: "namespaces", label: "namespaces", width: "1fr" },
  { key: "vectors", label: "vectors", width: "1fr" },
  { key: "searches", label: "searches·24h", width: "1fr" },
];

export default function SuperAdmin() {
  const all = useWorkspaceStore((s) => s.allWorkspaces);
  const load = useWorkspaceStore((s) => s.loadAllWorkspaces);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <Screen>
      <Prompt
        command="vf superadmin workspaces"
        comment="# requires superAdmin custom claim"
      />
      <div className={css.warnBanner}>
        ⚠ cross-tenant view — every workspace on this deployment
      </div>

      <DataTable<WorkspaceSummary>
        fontSize="12.5px"
        columns={COLUMNS}
        rows={all}
        rowKey={(w) => w.id}
        empty={
          <EmptyRow
            title="no workspaces"
            body="This deployment has no workspaces yet. One is auto-created on a user's first login."
          />
        }
        renderCell={(w, key) => {
          switch (key) {
            case "workspace":
              return (
                <span style={{ color: "var(--vf-text)" }}>
                  {w.id} <span style={{ color: "var(--vf-dim2)", fontSize: 11 }}>· {w.plan}</span>
                </span>
              );
            case "members":
              return <span style={{ color: "var(--vf-sec)" }}>{w.members}</span>;
            case "namespaces":
              return <span style={{ color: "var(--vf-acc)" }}>{w.namespaces}</span>;
            case "vectors":
              return <span style={{ color: "var(--vf-acc)" }}>{w.vectors}</span>;
            case "searches":
              return <span style={{ color: "var(--vf-ok)" }}>{w.searches}</span>;
            default:
              return null;
          }
        }}
      />
    </Screen>
  );
}
